import styled from 'styled-components';
import { Link } from 'gatsby';

const FooterMenuLink = styled(Link).attrs(() => ({
  className: 'block w-full pl-2 border-l-2 border-gray-800 py-1 text-sm text-gray-500 hover:text-red-500',
  activeClassName: 'border-l-2 border-red-500'
}))``;

export default FooterMenuLink;
